const modalsContext = require.context(".", false, /\.vue$/);
const modals = {};

modalsContext.keys().forEach((modalFile) => {
  const modalName = modalFile.replace(/(\.\/|\.vue)/g, "");
  modals[`${modalName}`] = modalsContext(modalFile).default;
});

export default modals;
